import { useState } from "react";
import SidenavItem from "./SidenavItem";
import { RxCross1 } from "react-icons/rx";

function SidenavMobile({ Menus, logo }) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [open, setOpen] = useState(false);
  return (
    <div className={`w-20 flex`}>
      <div
        className={`${
          open ? "w-72" : "w-20"
        } p-5 pt-9  bg-gray  duration-300 h-screen fixed top-0 left-0 bottom-0 overflow-y-auto z-10 bg-white dashboard-sidenav`}
      >
        <div
          className={`inline-flex ${
            open ? "w-72" : "w-20"
          } transition-all px-4 py-4 justify-between items-center fixed top-0 left-0 bg-white z-10`}
        >
          <button onClick={() => setOpen(!open)} className="inline-flex gap-2">
            <img
              className={`object-contain ${
                open ? "hidden" : "mt-[0.34rem] h-12"
              }`}
              src={logo || "/assets/logo/imdady_logo_small.png"}
              alt=""
            />
            <img
              className={`${open ? "" : "hidden"} h-12`}
              src={logo || "/assets/logo/imdady_logo.png"}
              alt=""
            />
          </button>
          <span className={`${open ? "" : "hidden"}`}>
            <button onClick={() => setOpen(!open)}>
                <RxCross1 className="text-2xl text-gray-500" />
            </button>
          </span>
        </div>
        <ul className="pt-2 mt-8">
          {Menus.map(
            (menu, index) =>
              user?.user.module_access &&
              JSON.parse(user?.user.module_access).includes(menu.title) && (
                <SidenavItem
                  key={index}
                  menu={menu}
                  open={open}
                //   hoverOpen={hoverOpen}
                  user={user}
                />
              )
          )}
        </ul>
      </div>
    </div>
  );
}

export default SidenavMobile;
